import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/@service/app.service';

interface Plan {
  id: string;
  display_order: number;
  plan: string;
  price: number;
  type: string;
  used: boolean;
}

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  studentCount = 1000;
  teacherCount = 30;

  plans: Plan[] = [];
  loading = false;
  errorMessage = '';

  constructor(private _appService: AppService) { }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    this.loading = true;

    this._appService.getprice().subscribe({
      next: (data: any) => {
        this.plans = data.items
          .map((item: any) => ({
            id: item.id,
            display_order: Number(item.display_order),
            plan: item.plan,
            price: Number(item.price) || 0,
            type: data.labels.type[item.type] ?? item.type,
            used: true
          }))
          .sort((a: Plan, b: Plan) => a.display_order - b.display_order);
      },
      error: error => {
       
      }
    });
  }

  onCheckboxChange(plan: Plan): void {
    plan.used = !plan.used;
  }

  onStudentCountChange(): void {
    // Template totals update automatically.
  }

  onTeacherCountChange(): void {
    // Template totals update automatically.
  }

  getIndStudentTotal(): number {
    return this.plans
      .filter(plan => plan.used && plan.type === 'Student Based')
      .reduce((total, plan) => total + plan.price, 0);
  }

  getStudentTotal(): number {
    return this.getIndStudentTotal() * this.studentCount;
  }

  getTeacherTotal(): number {
    return this.plans
      .filter(plan =>
        plan.used &&
        (plan.type === 'Staff Based' || plan.type === 'Teacher Based')
      )
      .reduce(
        (total, plan) => total + plan.price * this.teacherCount,
        0
      );
  }

  getStaticTotal(): number {
    return this.plans
      .filter(plan => plan.used && plan.type === 'Static')
      .reduce((total, plan) => total + plan.price, 0);
  }

  getGrandTotal(): number {
    return (
      this.getStudentTotal() +
      this.getTeacherTotal() +
      this.getStaticTotal()
    );
  }
}